<template>
  <div>
    <appHeader></appHeader>

    <!-- ═══════════════════════════════════════
         MOBILE FULL-SCREEN DRAWER
    ════════════════════════════════════════ -->
    <div class="mobile-drawer-page">

      <!-- ── Sticky top bar ── -->
      <div class="mobile-drawer-topbar">
        <div class="mobile-drawer-topbar__left">
          <span class="mobile-drawer-topbar__icon">✈</span>
          <span class="mobile-drawer-topbar__title">Services</span>
        </div>
        <router-link to="/shop" class="mobile-drawer-close" aria-label="Close">✕</router-link>
      </div>

      <!-- ── Body ── -->
      <div class="mobile-drawer-body" v-if="exclusiveCategories.length > 0">
        <div class="mobile-drawer-section">
          <p class="mobile-drawer-section__label">Available Services</p>
          <ul class="mobile-drawer-list">

            <li v-if="isTravelConciergeEnabled">
              <router-link :to="{ name: 'TravelEvents' }" class="mobile-drawer-item">
                <span class="svc-icon svc-icon--travel">✈</span>
                <span class="svc-text">
                  <strong>Travel &amp; Events</strong>
                  <small>Book travel and event experiences</small>
                </span>
                <span class="item-chevron">›</span>
              </router-link>
            </li>

            <li v-if="isCustomItemEnabled">
              <router-link :to="{ name: 'CustomItem' }" class="mobile-drawer-item">
                <span class="svc-icon svc-icon--custom">📦</span>
                <span class="svc-text">
                  <strong>Custom Items</strong>
                  <small>Request personalised products</small>
                </span>
                <span class="item-chevron">›</span>
              </router-link>
            </li>

            <li v-if="isTicketAndExperiencesEnabled">
              <router-link :to="{ name: 'TicketAndExperiences' }" class="mobile-drawer-item">
                <span class="svc-icon svc-icon--tickets">🎟</span>
                <span class="svc-text">
                  <strong>Tickets &amp; Experiences</strong>
                  <small>Events, shows and more</small>
                </span>
                <span class="item-chevron">›</span>
              </router-link>
            </li>

          </ul>
        </div>
      </div>

      <!-- Empty state -->
      <div class="mobile-drawer-body mobile-drawer-empty" v-else>
        <span class="empty-icon">🔍</span>
        <p>No services available at the moment.</p>
      </div>

      <!-- ── Sticky footer ── -->
      <div class="mobile-drawer-footer">
        <router-link to="/shop" class="back-btn-link">
          <button class="back-btn">← Back to Shop</button>
        </router-link>
      </div>

    </div>

    <navigationFooter></navigationFooter>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Header from "@/components/Header.vue";
import navigationFooter from "../../components/navigationFooter.vue";

export default {
  data() {
    return {
      searchId: 1,
    };
  },
  computed: {
    ...mapState({
      currentCategoryId: (state) => state.category.currentCategoryId,
      parentCategories: (state) => state.category.parents,
      childrenCategories: (state) => state.category.children,
      exclusiveCategories: (state) => state.category.exclusives,
    }),
    isTravelConciergeEnabled: function() {
      return (
        this.exclusiveCategories.filter((item) => item["type"] === "CONCIERGE")
          .length > 0
      );
    },
    isTicketAndExperiencesEnabled: function () {
      return (
        this.exclusiveCategories.filter(
          (item) => item["type"] === "TICKETSANDEXPERIENCES"
        ).length > 0
      );
    },
    isCustomItemEnabled: function() {
      return (
        this.exclusiveCategories.filter(
          (item) => item["type"] === "CUSTOM_ITEM"
        ).length > 0
      );
    },
  },
  components: {
    appHeader: Header,
    navigationFooter: navigationFooter,
  },
  methods: {},
  created() {
    this.$store.dispatch("category/fetchExclusives");
  },
};
</script>

<style lang="scss" scoped>

/* ═══════════════════════════════════════════
   FULL-SCREEN DRAWER SHELL
═══════════════════════════════════════════ */
.mobile-drawer-page {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #f7f8fc;
  z-index: 999;
  overflow: hidden;
}

/* ── Top bar ── */
.mobile-drawer-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 56px;
  background: #fff;
  border-bottom: 1px solid #eaecf4;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);

  &__left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff5ec;
    border-radius: 9px;
    font-size: 15px;
  }

  &__title {
    font-size: 17px;
    font-weight: 700;
    color: #2d3142;
    letter-spacing: -0.2px;
  }
}

.mobile-drawer-close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f1f5;
  border-radius: 50%;
  font-size: 16px;
  color: #555;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s, color 0.2s;

  &:hover {
    background: #e0e3f0;
    color: #2d3142;
    text-decoration: none;
  }
}

/* ── Scrollable body ── */
.mobile-drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 0;
  -webkit-overflow-scrolling: touch;
}

/* ── Section ── */
.mobile-drawer-section {
  padding: 0 16px;
}

.mobile-drawer-section__label {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.9px;
  color: #aab0c6;
  margin: 0 0 8px 4px;
}

/* ── List card ── */
.mobile-drawer-list {
  list-style: none;
  padding: 0;
  margin: 0;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #eaecf4;
  box-shadow: 0 1px 6px rgba(0,0,0,0.05);

  li + li {
    border-top: 1px solid #f0f1f5;
  }
}

/* ── Row item ── */
.mobile-drawer-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 14px 16px;
  background: #fff;
  text-decoration: none;
  color: #2d3142;
  transition: background 0.15s;

  &:hover, &:active {
    background: #f4f5ff;
    text-decoration: none;
    color: #4f6ef7;

    .svc-text strong { color: #4f6ef7; }
  }
}

/* ── Service icon badge ── */
.svc-icon {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  font-size: 18px;

  &--travel  { background: #e8f4ff; }
  &--custom  { background: #fff3e0; }
  &--tickets { background: #f3e8ff; }
}

/* ── Text block ── */
.svc-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;

  strong {
    font-size: 14.5px;
    font-weight: 600;
    color: #2d3142;
    line-height: 1.3;
  }

  small {
    font-size: 12px;
    color: #9499b0;
    font-weight: 400;
    line-height: 1.3;
  }
}

/* ── Chevron ── */
.item-chevron {
  color: #ccc;
  font-size: 20px;
  font-weight: 300;
  line-height: 1;
  flex-shrink: 0;
}

/* ── Empty state ── */
.mobile-drawer-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #aab0c6;

  .empty-icon { font-size: 40px; }

  p {
    font-size: 14px;
    text-align: center;
    margin: 0;
  }
}

/* ── Sticky footer ── */
.mobile-drawer-footer {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-top: 1px solid #eaecf4;
  flex-shrink: 0;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.06);
}

.back-btn-link {
  width: 100%;
  text-decoration: none;
}

.back-btn {
  width: 100%;
  height: 46px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #4f6ef7, #6c85fa);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 3px 12px rgba(79,110,247,0.35);
  transition: opacity 0.2s, box-shadow 0.2s;
  letter-spacing: 0.2px;

  &:hover {
    opacity: 0.92;
    box-shadow: 0 4px 16px rgba(79,110,247,0.45);
  }
}
</style>